module.exports = __webpack_public_path__ + "static/media/02_2.ecb485fe.png";